import { EventTask } from 'nekst-api';
import React, { useState } from 'react';
import { LoadingAnimation } from 'ui-builder';
import useDataLoader from 'data-loader';
import { EventPreviewResponse, useEventPreviewService } from './eventPreviewService';
import Layout from './Layout';

export function EventPreview(
  props: {
    task: EventTask;
  }
) {
  const task = props.task;

  const [eventPreview, setEventPreview] = useState<EventPreviewResponse>();

  const previewService = useEventPreviewService();

  useDataLoader(
    async () => {
      if (task.id) {
        return previewService.getEventPreview(task.id, task)
      } else {
        return previewService.getEventPreviewForProject(task.projectId, task);
      }
    },
    (response: EventPreviewResponse) => {
      setEventPreview(response);
    },
  );

  if (eventPreview) {
    return (
      <Layout
        preview={eventPreview}
        timezone={task.dueDate?.timezone}
      />
    );
  } else {
    return (
      <LoadingAnimation />
    );
  }
}
